import React from 'react';
import './Row.scss';

const Row = (props) => (
    <div className="row">
        {props.children}
    </div>
)

const RowColoumn = (props) => (
    <div className="rowColoumn" style={props.style}>
        {props.children}
    </div>
)

const RowTitle = (props) => (
    <div className="row_title">
        {props.children}
    </div>
)

const RowHeader = (props) => (
    <div className="row_header">
        {props.children}
    </div>
)
const RowList = (props) => (
    <div className="row_list">
        {props.children}
    </div>
)

export {
    Row,
    RowHeader,
    RowTitle,
    RowColoumn,
    RowList
}